import React, {useState, useEffect, useRef} from 'react';

import tomato from '../../assets/powers/tomato.svg';
import flashbang from '../../assets/powers/flash.svg';
import roses from '../../assets/powers/roses.svg';
import heart from '../../assets/powers/heart.svg';
import govno from '../../assets/powers/govno.svg';
import govno_rainbow from '../../assets/powers/govno_rainbow.svg';

const stylesDict = {
    marginTop: 80,
    position : 'absolute',
    width: 75
}  as React.CSSProperties;

export default function StreamImageComponent(props:any) {
    return (
        <img style={stylesDict} src={props.url} />
    );
    if(props.powerType === 'flash'){
        return(
            <img style={stylesDict} src={flashbang} />
        );
    }
    else if(props.powerType === 'tomato'){
        return(
            <img style={stylesDict} src={tomato} />
        );
    }
    else if(props.powerType === 'hearts'){
        return(
            <img style={stylesDict} src={heart} />
        );
    }
    else if(props.powerType === 'poop'){
        return(
            <img style={stylesDict} src={govno} />
        );
    }
    else if(props.powerType === 'rainbowpoop'){
        return(
            <img style={{...stylesDict, marginTop: 86}} src={govno_rainbow} />
        );
    }
    else if(props.powerType === 'roses'){
        return(
            <img style={stylesDict} src={roses} />
        );
    }
    else{
        return (
            <img style={stylesDict} src={flashbang} />
        );
    }
}
